import { configureStore, Action, getDefaultMiddleware } from '@reduxjs/toolkit'
import api from './api';
import { ThunkAction } from 'redux-thunk'
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER
} from 'redux-persist';
import rootReducer, { RootState } from './rootReducer';
import sessionStorage from 'redux-persist/lib/storage'
import signalRMiddleware from './middlewares/signalr-middleware'

const persistConfig = {
    key: 'root',
    storage: sessionStorage,
    blacklist: ['appState', 
    'plannerStore', 
    'plannerModalStore', 
    'plannerYellowBorderStore',
    'plannerDraggingTripStore',
    'plannerLoadingStore'
]  
}

const persistedReducer = persistReducer(persistConfig, rootReducer)
const appStore = configureStore({
    reducer: persistedReducer,
    // devTools: true, // for dev
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER
                , 'plannerStore/applyGlobalChanges'
                , 'plannerStore/applyLocalChangesForTimeline'
                , 'plannerModalStore/showTripDetailsModal'
                , 'plannerYellowBorderStore/setShowYellowBorder'
                , 'plannerDraggingTripStore/setDraggingTripId'
                , 'plannerLoadingStore/setLoading'
                , 'appState/showNavbar'
                , 'appState/showBookingToast'
            ]
        }
    }).concat(signalRMiddleware)
});

appStore.subscribe(function () {
   
    let state = appStore.getState();
    api.setToken(state.authStore.token ?? '');
})
const persistor = persistStore(appStore);

//if (process.env.NODE_ENV === 'development' && module.hot) {
//    module.hot.accept('./rootReducer', () => {
//        const newRootReducer = require('./rootReducer').default
//        appStore.replaceReducer(newRootReducer)
//    })
//}

export type AppDispatch = typeof appStore.dispatch;
export type AppThunk<R> = ThunkAction<R, RootState, null, Action<string>>;

export default { appStore, persistor };